import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  consumeGoogleCalendarOAuthReturnLu,
  consumeGoogleCalendarOAuthReturnOrgId,
} from "./U3201GoogleCalendarOAuthReturn";

/**
 * Si Google OAuth renvoie vers la racine (`/?googleCalendar=connected`), redirige vers la fiche
 * U2104 ou U3148 de l'organisation mémorisée avant le flux OAuth.
 */
export function useU3201GoogleCalendarOAuthReturnRedirect(): void {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("googleCalendar") !== "connected") return;

    const orgIdFromU2104 = location.pathname.match(/^\/U2104\/([^/]+)$/)?.[1];
    const orgIdFromU3148 = location.pathname.match(/^\/U3148\/([^/]+)$/)?.[1];
    if (orgIdFromU2104 || orgIdFromU3148) return;

    const orgId = consumeGoogleCalendarOAuthReturnOrgId();
    if (!orgId) return;

    const logicalUnit = consumeGoogleCalendarOAuthReturnLu();
    navigate(`/${logicalUnit}/${orgId}?googleCalendar=connected`, { replace: true });
  }, [location.pathname, location.search, navigate]);
}
